import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { InputField, withFieldProps, withLoading } from '@adjust/dashboard-components';

import { validate, isRequired, isEmail } from '@adjust/dashboard-core/lib/validations';

const validation = {
  email: [
    [isRequired, () => t('field.email.error')],
    [isEmail, () => t('field.email.error')],
  ],
};

const EditUserEmailFormBase = ({
  email,
  initialEmail,
  isEmailOwner,
  unconfirmedEmail,
  resendConfirmationEmail,
  onSave,
  onCancel,
}) => (
  <Formik initialValues={{ email }} onSubmit={values => onSave(values.email)}>
    {({ isValid, values }) => (
      <Form className="flex-one flex-box-column">
        <div className="flex-one content-inner form-row">
          <p className="info small">
            {isEmailOwner ? t('users.email-update.message') : t('users.email-update.message-admin')}
          </p>

          <Field name="email" validate={validate(validation.email)}>
            {withFieldProps(<InputField label={t('field.email')} />)}
          </Field>

          {unconfirmedEmail && (
            <p className="info warning small with-icon">
              <i className="icon-warning icon-unconfirmed-email" />
              <span>{t('users.email-update.warning-message', { email: unconfirmedEmail })}</span>
              <button type="button" className="btn-link" onClick={resendConfirmationEmail}>
                {t('action.resend-confirmation-email')}
              </button>
            </p>
          )}
        </div>

        <div className="flex-auto inner-panel-footer">
          <div className="flex-box-row">
            <button type="button" className="btn flex-one" onClick={onCancel}>
              {t('action.cancel')}
            </button>
            <button
              type="submit"
              className="btn btn-main flex-one"
              disabled={!isValid || initialEmail === values.email}
            >
              {t('action.save')}
            </button>
          </div>
        </div>
      </Form>
    )}
  </Formik>
);

EditUserEmailFormBase.propTypes = {
  email: PropTypes.string.isRequired,
  initialEmail: PropTypes.string.isRequired,
  isEmailOwner: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  unconfirmedEmail: PropTypes.string,
  resendConfirmationEmail: PropTypes.func,
};

const EditUserEmailForm = withLoading(EditUserEmailFormBase);

EditUserEmailForm.propTypes = {
  ...EditUserEmailFormBase.propTypes,
  isLoading: PropTypes.bool,
};

export { EditUserEmailForm };
